import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Bell(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M5.816 11.975l.022-4.459V7.51c0-3.18 2.702-5.86 6.164-5.86 3.461 0 6.163 2.68 6.163 5.86v.085l.002.042.001.018.002.05.003.16a285.86 285.86 0 01.017 1.87c.006.99.009 1.991.009 2.237 0 1.542.333 2.789.987 3.739.41.595.91 1.022 1.438 1.318H3.384a4.268 4.268 0 001.442-1.317c.656-.95.99-2.196.99-3.736zM4.338 7.509l-.022 4.462c0 2.666-1.151 3.695-2.336 4.02-.587.164-1.005.663-1.005 1.248 0 .715.598 1.289 1.343 1.289h19.367c.745 0 1.343-.574 1.343-1.289 0-.585-.417-1.084-1.004-1.247-1.174-.326-2.325-1.355-2.325-4.021 0-.499-.011-4.018-.034-4.419V7.51c0-4.064-3.43-7.36-7.663-7.36-4.233 0-7.664 3.296-7.664 7.36zm4.815 12.438a.75.75 0 10-1.46.342 4.424 4.424 0 004.309 3.41 4.423 4.423 0 004.306-3.402.75.75 0 00-1.46-.345 2.923 2.923 0 01-2.846 2.248 2.924 2.924 0 01-2.849-2.253z"
  }));
}

export { Bell };
//# sourceMappingURL=Bell.js.map